export default __webpack_public_path__ + "static/media/csmlogo.9c5d6cc0.png";